import classNames from 'classnames';
import { useEffect, useState } from 'react';

import { Call } from '@/icons/index';

import styles from './LinkNumbers.module.scss';

export const bgVariants = {
  bgWhite: 'link-numbers__item',
  bgTransparent: 'link-numbers__item--blurred',
};

const LinkNumbers = ({
  numbers,
  isNotLink,
  isTel,
  className,
  dark = false,
  isLight,
  bgVariant = bgVariants.bgTransparent,
}) => {
  const [activateTelIcon, setActivateTelIcon] = useState(false);
  const [ussd, setUssd] = useState('');
  const [middleDesc, setMiddleDesc] = useState('');
  const itemClass = {
    [styles[bgVariants.bgWhite]]: bgVariant === bgVariants.bgWhite,
    [styles[bgVariants.bgTransparent]]: bgVariant === bgVariants.bgTransparent,
  };

  const replaceHandle = (arr) => {
    return arr?.map((item) => {
      return item?.substring(3, item.length - 3);
    });
  };

  useEffect(() => {
    const newUssd = Array.isArray(numbers) ? numbers?.join('') : numbers;

    // setUssd(newUssd.match(/(?<=<-\s+).*?(?=\s+->)/g));
    // setMiddleDesc(newUssd.match(/(?<==>\s+).*?(?=\s+<=)/g));
    setUssd(replaceHandle(newUssd.match(/<-.*?->/g)));
    setMiddleDesc(replaceHandle(newUssd.match(/=>.*?<=/g)));
    setActivateTelIcon(numbers.indexOf('yes') > -1);
  }, [numbers]);
  const LINK_CONTAINER_CLASS = 'link-numbers';

  const FULL = 'link-numbers__full';
  const renderNumber = (item) => {
    return [...item.join('').replace('yes', '')].map((str, index) => {
      return (
        <span
          className={classNames([itemClass, { [styles.dark]: dark }])}
          key={index}
          itemScope
          itemType='http://schema.org/Text'
        >
          {str}
        </span>
      );
    });
  };

  if (isNotLink || middleDesc) {
    return (
      <div
        className={classNames([
          styles[LINK_CONTAINER_CLASS],
          className,
          { [styles['link-numbers--light']]: isLight },
        ])}
        itemScope
        itemType='http://schema.org/Property'
      >
        {ussd && <div>{[ussd]?.map(renderNumber)}</div>}
        {middleDesc && (
          <span
            className={classNames([
              itemClass,
              styles[FULL],
              { [styles.dark]: dark },
            ])}
          >
            {middleDesc}
          </span>
        )}
        {isTel && (
          <span className={classNames([itemClass, { [styles.dark]: dark }])}>
            <Call />
          </span>
        )}
      </div>
    );
  }
  return (
    <>
      {ussd && (
        <a
          href={`tel:${ussd[0]?.replace('yes', '').replace(/#/g, '%23')}`}
          className={classNames([
            styles[LINK_CONTAINER_CLASS],
            className,
            { [styles['link-numbers--light']]: isLight },
          ])}
          itemScope
          itemType='http://schema.org/Thing'
        >
          {ussd && (
            <div className={styles['inner-container']}>
              {[ussd]?.map(renderNumber)}
            </div>
          )}

          {activateTelIcon && (
            <span className={classNames([itemClass, { [styles.dark]: dark }])}>
              <Call />
            </span>
          )}
        </a>
      )}
    </>
  );
};

export default LinkNumbers;
